import axios from 'axios'
import axiosRetry from "axios-retry";
import store from '@/store';
import { requestOptions } from '@/helpers/request-options'

const exportApiClient = axios.create({
})

axiosRetry(exportApiClient, {
    retries: 3,
    retryDelay: () => 3000,
    retryCondition: () => true,
});

const apiSource = process.env.VUE_APP_API;

export default {
    Insert(puid, queueRequest) {
        return exportApiClient(
            requestOptions.postData(
                queueRequest,
                apiSource + `/api/v1/${store.state.instance}/export/Queue?puid=${puid}`
            )
        )
    },
    Check(token) {
        return exportApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/export/Check?token=${token}`
            )
        )

    },
    Download(token) {
        return exportApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/export/Download?token=${token}`
            )
        )
    }
}